export interface SelectedPhotoData {
    fileName: string;
    fileType: string;
    photoData: string;
}
